import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

// Authentication Libraries
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./utils/azureConfig";

// Styles
import "react-block-ui/style.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

// import i18n (needs to be bundled ;))
import "./locales";

// Load Mocks
import "./__mocks__";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Globals
const USE_STRICT_MODE = false;
const Wrapper = USE_STRICT_MODE ? React.StrictMode : React.Fragment;

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <Wrapper>
    <MsalProvider instance={msalInstance}>
      <App data-testid="index" />
    </MsalProvider>
  </Wrapper>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
